import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "w-full flex justify-between items-center" };
const _hoisted_2 = { class: "text-[16px]" };
const _hoisted_3 = { class: "subtitle-container" };
const _hoisted_4 = { class: "text-[var(--color-50)] text-[12px]" };
const _hoisted_5 = { class: "text-[12px]" };
const _hoisted_6 = { class: "text-[12px]" };
const _hoisted_7 = { class: "accordion" };
const _hoisted_8 = ["onClick"];
import moment from "moment";
import UArrow from "@/components/uikit/uComponents/UArrow.vue";
import UDivider from "@/components/uikit/uComponents/UDivider.vue";
import UTextStepper from "@/components/uikit/uComponents/UTextStepper.vue";
import { computed, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FundingTimeline',
    props: {
        dateEnd: {
            type: String,
            required: true
        }
    },
    setup(__props) {
        const props = __props;
        const openIndex = ref(null);
        const toggle = (index) => {
            openIndex.value = openIndex.value === index ? null : index;
        };
        const formattedDateEnd = computed(() => {
            return moment(props.dateEnd, "DD.MM.YYYY").format("DD.MM.YYYY");
        });
        const phases = [
            {
                title: "Phase 1 — Fundraising",
                text: "You invest — funds are reserved to finance the property.",
                subTitle: "Closing date: ",
                subText: formattedDateEnd.value,
                icon: "/img/capital/funding_timeline_1.svg",
                items: [
                    {
                        title: "Investing",
                        text: "«You choose an amount and confirm the payment.»"
                    },
                    {
                        title: "Escrow active",
                        text: "«Funds are reserved in the escrow account.»"
                    },
                    {
                        title: "Fundraising closes",
                        text: "«The round is locked once the target is reached or on the closing date.»"
                    }
                ]
            },
            {
                title: "Phase 2 — Legal structure",
                text: "An SPV is formed and investors’ shares are legally established.",
                subTitle: "Expected: ",
                subText: moment(props.dateEnd, "DD.MM.YYYY").add(14, "days").format("DD.MM.YYYY"),
                icon: "/img/capital/funding_timeline_2.svg",
                items: [
                    {
                        title: "SPV formation",
                        text: "«Registration of a special-purpose company that will own the property.»",
                        tooltip: "SPV — a special purpose vehicle for holding the asset and distributing income"
                    },
                    {
                        title: "Issuance of shares / certificates",
                        text: "«Confirmation of your share and participation terms.»"
                    }
                ]
            },
            {
                title: "Phase 3 — Property acquisition",
                text: "The SPV completes the deal and registers ownership",
                subTitle: "Expected: ",
                subText: "1 week (example guideline)",
                icon: "/img/capital/funding_timeline_3.svg",
                items: [
                    {
                        title: "SPA",
                        text: "«Signing the Sale and Purchase Agreement.»"
                    },
                    {
                        title: "DLD transfer",
                        text: "«Registration of the transfer of ownership.»"
                    }
                ]
            },
            {
                title: "Phase 4 — Operations and income",
                text: "Leasing, management, and income distribution.",
                subTitle: "Expected: ",
                subText: "ongoing / continuous",
                icon: "/img/capital/funding_timeline_4.svg",
                items: [
                    {
                        title: "Preparation and leasing",
                        text: "«Finding a tenant / launching the lease.»"
                    },
                    {
                        title: "Management",
                        text: "«Operational management of the property.»"
                    },
                    {
                        title: "Distributions",
                        text: "«Scheduled payouts to investors.»"
                    }
                ]
            },
            {
                title: "Phase 5 — Exit",
                text: "Executing the exit strategy and distributing proceeds",
                subTitle: "Right: Expected: ",
                subText: "3–7 years",
                icon: "/img/capital/funding_timeline_5.svg",
                items: [
                    {
                        title: "Threshold conditions",
                        text: "«Reaching the conditions by time/price/strategy.»"
                    },
                    {
                        title: "Vote / decision (if applicable)",
                        text: "«Approval of the exit scenario.»"
                    },
                    {
                        title: "Sale and distribution",
                        text: "«Proceeds are distributed proportionally to shares.»"
                    }
                ]
            }
        ];
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            const _component_UList = _resolveComponent("UList");
            const _component_UContent = _resolveComponent("UContent");
            return (_openBlock(), _createBlock(_component_UContent, {
                "has-padding": false,
                "has-title-delimiter": false
            }, {
                header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode(" Project timeline ", -1)
                    ]))]),
                default: _withCtx(() => [
                    _createVNode(_component_UContent, { "is-card-bordered": true }, {
                        default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(phases, (phase, index) => {
                                return _createVNode(_component_UList, {
                                    key: index,
                                    "flex-direction": "row"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_UList, {
                                            "flex-direction": "row",
                                            class: "w-full"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_UList, { "align-items": "center" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_UIcon, {
                                                            "icon-size": "46px",
                                                            icon: phase.icon
                                                        }, null, 8, ["icon"]),
                                                        (index < phases.length - 1)
                                                            ? (_openBlock(), _createBlock(UArrow, {
                                                                key: 0,
                                                                length: phase.items.length * 10 + 20
                                                            }, null, 8, ["length"]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_UList, {
                                                    gap: "10px",
                                                    class: "w-full"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_UList, {
                                                            "flex-direction": "row",
                                                            gap: "20px",
                                                            class: "w-full"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_UList, {
                                                                    gap: "5px",
                                                                    class: "w-full"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createElementVNode("div", _hoisted_1, [
                                                                            _createElementVNode("div", _hoisted_2, _toDisplayString(phase.title), 1),
                                                                            _createElementVNode("div", _hoisted_3, [
                                                                                _createElementVNode("span", _hoisted_4, _toDisplayString(phase.subTitle), 1),
                                                                                _createElementVNode("span", _hoisted_5, _toDisplayString(phase.subText), 1)
                                                                            ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_6, _toDisplayString(phase.text), 1),
                                                                        _createElementVNode("div", _hoisted_7, [
                                                                            _createElementVNode("div", {
                                                                                class: "show text-[12px]",
                                                                                onClick: ($event) => (toggle(index))
                                                                            }, [
                                                                                _cache[1] || (_cache[1] = _createTextVNode(" Show more ", -1)),
                                                                                _createElementVNode("span", {
                                                                                    class: _normalizeClass(["arrow", { 'arrow-up': openIndex.value === index }])
                                                                                }, [
                                                                                    _createVNode(_component_UIcon, {
                                                                                        "icon-size": "12px",
                                                                                        icon: "chevron_down_green"
                                                                                    })
                                                                                ], 2)
                                                                            ], 8, _hoisted_8),
                                                                            _createElementVNode("div", {
                                                                                class: _normalizeClass(["show-info", { 'show-info-open': openIndex.value === index }])
                                                                            }, [
                                                                                true
                                                                                    ? (_openBlock(), _createBlock(_component_UList, {
                                                                                        key: 0,
                                                                                        gap: "5px"
                                                                                    }, {
                                                                                        default: _withCtx(() => [
                                                                                            _cache[2] || (_cache[2] = _createElementVNode("div", null, " Steps (stepper): ", -1)),
                                                                                            _createVNode(UTextStepper, {
                                                                                                items: phase.items
                                                                                            }, null, 8, ["items"])
                                                                                        ]),
                                                                                        _: 2
                                                                                    }, 1024))
                                                                                    : _createCommentVNode("", true)
                                                                            ], 2)
                                                                        ])
                                                                    ]),
                                                                    _: 2
                                                                }, 1024)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        (index < phases.length - 1)
                                                            ? (_openBlock(), _createBlock(UDivider, { key: 0 }))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    _: 2
                                }, 1024);
                            }), 64))
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
